import Kefir from 'kefir';

/**
 * Accepts a varying number of types, and returns a function that
 * takes an Observable of actions and filters them based on the
 * types provided. Reads `action.type` to match.
 *
 * Checks loosely against action.type, which should always be
 * a string, as this is intended to be used with with the actions
 * emitted from a Redux store. This is exposed so it works with
 * redux-actions' action creator functions, which come with
 * `toString` to allow loose comparison.
 *
 * Intended to be used with Kefir's `thru` method.
 */
function ofType() {
  for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
    types[_key] = arguments[_key];
  }

  return function (obs$) {
    return obs$.filter(function (action) {
      var type = action.type;
      var len = types.length;

      if (len === 1) {
        // eslint-disable-next-line eqeqeq
        return type == types[0];
      } else {
        for (var i = 0; i < len; i++) {
          // eslint-disable-next-line eqeqeq
          if (types[i] == type) {
            return true;
          }
        }
      }

      return false;
    }).setName(obs$, 'ofType');
  };
}

/**
 * Emitted on requestAnimationFrame callbacks.
 */

var RAF = 'RAF';
/**
 * Create a new raf action.
 */

var rafAction = Object.assign(function (time) {
  return {
    type: RAF,
    payload: {
      time: time
    }
  };
}, {
  getType: function getType() {
    return RAF;
  },
  toString: function toString() {
    return RAF;
  }
});
/**
 * The type emitted by the raf$ stream.
 */

/**
 * Stream of requestAnimationFrame events.
 */
var raf$ = Kefir.stream(function (emitter) {
  var loop;
  var enabled = true;

  (function schedule() {
    loop = requestAnimationFrame(function (time) {
      emitter.value(rafAction(time));

      if (enabled) {
        schedule();
      }
    });
  })();

  return function () {
    cancelAnimationFrame(loop);
    enabled = false;
  };
});

var $$initialized = Symbol('init');
var view = (function (callback) {
  return function (stream$) {
    var previous = $$initialized;
    return stream$.withHandler(function (emitter, event) {
      switch (event.type) {
        case 'end':
          emitter.end();
          break;

        case 'error':
          emitter.error(event.value);
          break;

        case 'value':
          var next = callback(event.value);

          if (previous === $$initialized || next !== previous) {
            previous = next;
            emitter.value(next);
          }

          break;
      }
    });
  };
});

export { RAF, ofType, raf$, rafAction, view };
